import { TiktokIcon } from "@/Icons";
import { cn } from "@/lib/utils";
import { PlayIcon } from "lucide-react";
import { useState } from "react";

type TiktokThumbnailProps = {
  artworkUrl?: string | null;
  className?: string;
  size?: "default" | "lg";
};

export default function TiktokThumbnail({
  artworkUrl,
  className,
  size = "default",
}: TiktokThumbnailProps) {
  // Local state
  const [failedUrl, setFailedUrl] = useState<string | null>(null);

  return (
    <div
      className={cn(
        "relative flex items-start justify-end p-[8%] bg-linear-to-br from-rose-500 via-pink-500 to-fuchsia-600",
        className
      )}
    >
      {artworkUrl && failedUrl !== artworkUrl && (
        <img
          alt=""
          className="absolute inset-0 size-full object-cover"
          loading="lazy"
          src={artworkUrl}
          onError={() => setFailedUrl(artworkUrl)}
        />
      )}

      <TiktokIcon
        className="relative z-10 w-1/6 h-auto text-white drop-shadow"
        aria-hidden
      />

      <PlayIcon
        className={cn(
          "absolute top-1/2 left-1/2 z-10 -translate-1/2 fill-white stroke-white drop-shadow",
          size === "lg" ? "size-16" : "size-9"
        )}
      />
    </div>
  );
}
